import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var ReceiveMaterialDetailsRes;
export const ReceiveMaterialDetailsTodo = createAsyncThunk('ReceiveMaterialDetails', async (data) => {
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'imt_receive_detail',
            headers: { "Content-Type": "application/json" },
            data:{
                "vchallan_code": data
            },
        })
        return ReceiveMaterialDetailsRes = res.data

    } catch (error) {
        return ReceiveMaterialDetailsRes = error.response.data
    }
});

const ReceiveMaterialDetailsSlice = createSlice({
    name: 'ReceiveMaterialDetails',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(ReceiveMaterialDetailsTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('userList', state.data)
        });
        builder.addCase(ReceiveMaterialDetailsTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default ReceiveMaterialDetailsSlice.reducer; 